import { BFormGroup } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBFormGroup when migrating. */
export const EgBFormGroup = createEgBootstrapProxy("EgBFormGroup", BFormGroup);
